
// src/actions/diary-report.js

import api from './gamba-api'
import { emitAlertMessage } from './alert-message'

export const FETCH_DIARY_REPORT = "FETCH_DIARY_REPORT"
export const FETCH_DIARY_REPORT_REQUESTED = "FETCH_DIARY_REPORT_REQUESTED"
export const FETCH_DIARY_REPORT_COMPLETED = "FETCH_DIARY_REPORT_COMPLETED"
export const FETCH_DIARY_REPORT_FAILED = "FETCH_DIARY_REPORT_FAILED"

export function fetchDiaryReportRequested() {
  return {
    type: FETCH_DIARY_REPORT_REQUESTED
  }
}

export function fetchDiary(group_id) {
  return function(dispatch) {
    dispatch(fetchDiaryReportRequested())
    return api.get(`/diary_report_settings/${group_id}`)
      .then((results)=> {
        dispatch(fetchDiaryReportCompleted(results))
      })
      .catch((error)=> {
        Promise.all([
          dispatch(fetchDiaryReportFailed(error)),
          dispatch(emitAlertMessage(error, 'error'))
        ])
      })
  }
}

export function fetchDiaryReportCompleted(results) {
  return {
    type: FETCH_DIARY_REPORT_COMPLETED,
    results,
  }
}

export function fetchDiaryReportFailed(error) {
  return {
    type: FETCH_DIARY_REPORT_FAILED,
    error,
  }
}

export const POST_DIARY_REPORT = "POST_DIARY_REPORT"
export const POST_DIARY_REPORT_REQUESTED = "POST_DIARY_REPORT_REQUESTED"
export const POST_DIARY_REPORT_COMPLETED = "POST_DIARY_REPORT_COMPLETED"
export const POST_DIARY_REPORT_FAILED = "POST_DIARY_REPORT_FAILED"

export function putDiaryReportRequested(group_id, is_weekly_report, is_monthly_report, weekly_report_start_date, monthly_report_start_date, input_diary_user_count) {
  return {
    type: POST_DIARY_REPORT_REQUESTED,
    group_id, is_weekly_report, is_monthly_report, weekly_report_start_date, monthly_report_start_date, input_diary_user_count
  }
}

export function putDiaryReportReport(group_id, is_weekly_report, is_monthly_report, weekly_report_start_date, monthly_report_start_date, input_diary_user_count) {
  return function(dispatch) {
    dispatch(putDiaryReportRequested(group_id, is_weekly_report, is_monthly_report, weekly_report_start_date, monthly_report_start_date, input_diary_user_count))
    return api.put(`/diary_report_settings`, { group_id, is_weekly_report, is_monthly_report, weekly_report_start_date, monthly_report_start_date, input_diary_user_count })
        .then((results)=> {
          dispatch(putDiaryReportCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(putDiaryReportFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function putDiaryReportCompleted(results) {
  return {
    type: POST_DIARY_REPORT_COMPLETED,
    results,
  }
}

export function putDiaryReportFailed(error) {
  return {
    type: POST_DIARY_REPORT_FAILED,
    error,
  }
}



// WEBPACK FOOTER //
// ./src/actions/diary-report.js